
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useEffect } from 'react';
import createEffectWithTarget from './createEffectWithTarget.js';

var useEffectWithTarget = createEffectWithTarget(useEffect);
var useEffectWithTarget$1 = useEffectWithTarget;

export { useEffectWithTarget$1 as default };
//# sourceMappingURL=useEffectWithTarget.js.map
